// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"sp-z","slideIn":"tp-z"};